<script lang="ts">
	import { inview } from 'svelte-inview';

	const { season, allTime } = $props();

	const seasonStats = season ? season[0] : false;
	const allTimeStats = allTime ? allTime[0] : false;

	let statChoice: string = $state('season');
</script>

{#if seasonStats || allTimeStats}
    <div
        class="player-card__stats--display"
        use:inview={{
            threshold: 0.9
        }}
        oninview_enter={(event) => {
            const { node } = event.detail;
            node.classList.add('show');
        }}
    >
        {#if seasonStats.show_stats && allTimeStats.show_stats}
            <div class="player-card__stats--selector">
                {#if seasonStats.show_stats}
                    <button class:active={statChoice == 'season'}>{'Season'}</button>
                {/if}

                {#if allTimeStats.show_stats}
                    <button class:active={statChoice == 'allTime'}>{'All Time'}</button>
                {/if}
            </div>
        {/if}

        {#if statChoice === 'season'}
            <div class="player-card__stats--section">
                <div class="player-card__stats">
                    <span class="title">GP</span>
                    <span class="value">{seasonStats.games_played ?? 0}</span>
                </div>

                <div class="player-card__stats">
                    <span class="title">G</span>
                    <span class="value">{seasonStats.goals ?? 0}</span>
                </div>

                <div class="player-card__stats">
                    <span class="title">A</span>
                    <span class="value">{seasonStats.assists ?? 0}</span>
                </div>

                <div class="player-card__stats">
                    <span class="title">PIM</span>
                    <span class="value">{seasonStats.penalty_minutes ?? 0}</span>
                </div>
            </div>
        {/if}

        {#if statChoice === 'allTime'}
            <div class="player-card__stats--section"></div>
        {/if}
    </div>
{/if}
